export default __webpack_public_path__ + "static/media/toggle-edges-off.d955796f.svg";